
import './MessageStats.css';
import api from '../api.js';
import { useEffect, useState } from "react";
import historyLogo from "../imgs/history.svg";

export default function MessageStats() {
    const me = JSON.parse(localStorage.getItem("me") || "{}");
    const role = me?.userInfo?.role;
    const myPartnerName = me?.userInfo?.partnerName;

    const [partners, setPartners] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState("");
    const [stats, setStats] = useState([]);
    const [error, setError] = useState("");
    const [total, setTotal] = useState({});

    const token = localStorage.getItem("token");

    const today = new Date().toISOString().split("T")[0];

    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);

    const [messages, setMessages] = useState([]);

    const [destinations, setDestinations] = useState([]);
    const [statuses, setStatuses] = useState([]);

    const [selectedDestination, setSelectedDestination] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    const [loading, setLoading] = useState(false);

    const [summary, setSummary] = useState({
        sent: 0, delivered: 0, error: 0, enqueued: 0, read: 0, total: 0, totalCost: 0,
    });

    const formatCost = (value) => Number(value || 0).toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const items_per_page = 50;
    const [currentPage, setCurrentPage] = useState(1);

    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [selectedMessageHistory, setSelectedMessageHistory] = useState([]);
    const [selectedMessageInfo, setSelectedMessageInfo] = useState(null);
    const [partnerWithSelectedMessage, setPartnerWithSelectedMessage] = useState("");

    const openHistoryModal = (m) => {
        setSelectedMessageInfo(m);
        setSelectedMessageHistory(m.history || []);
        setIsHistoryOpen(true);
        setPartnerWithSelectedMessage(m.partner);
    };

    const closeHistoryModal = () => {
        setIsHistoryOpen(false);
        setSelectedMessageInfo(null);
        setSelectedMessageHistory([]);
        setPartnerWithSelectedMessage("");
    };

    const fetchPartners = async () => {
        try {
            const res = await api.get("/api/partners/list", {
            });
            setPartners(res.data);
        } catch {
            setError("Ошибка при загрузке партнеров");
        }
    };

    const fetchMessages = async (overridePartner = null) => {
        try {
            setCurrentPage(1);
            setLoading(true);
            setError("");

            const params = {
                from: fromDate,
                to: toDate,
            };

            if (role === "Партнер") {
                params.partnerName = myPartnerName;
            }

            if (role === "Админ") {
                const partner = overridePartner !== null ? overridePartner : selectedPartner;
                if (partner) {
                    params.partnerName = partner;
                }
            }

            if (selectedDestination) params.destination = selectedDestination;
            if (selectedStatus) params.status = selectedStatus;

            const res = await api.get("/api/messages/allMessages", { params });
            setMessages(res.data);
            setLoading(false);
        } catch (err) {
            setError(err.response?.data || "Ошибка загрузки сообщений");
            setMessages([]);
            setLoading(false);
        }
    };

    const fetchInitialStats = () => {
        if (role === "Админ") {
            fetchMessages(selectedPartner || undefined);
        }

        if (role === "Партнер") {
            // console.log("PARTNER ", myPartnerName);
            fetchMessages(myPartnerName);
        }
    };


    useEffect(() => {
        document.title = "Сообщения - WAve";
        if (!role) return;

        if (role === "Админ") {
            fetchPartners();
            fetchMessages();
        }

        if (role === "Партнер") {
            if (!myPartnerName) {
                setError("Ваша учетная запись не привязана к партнеру");
                return;
            }

            setSelectedPartner(myPartnerName);
            fetchMessages(myPartnerName);
        }
    }, [role]);

    const handleFilterSubmit = (e) => {
        e.preventDefault();

        const partnerName =
            role === "Админ"
                ? selectedPartner || undefined
                : myPartnerName;

        fetchMessages(partnerName);
    };


    const handleSelectChange = (e) => {
        setSelectedPartner(e.target.value);
    };

    const statusTranslations = {
        sent: "Отправлено",
        delivered: "Доставлено",
        failed: "Не отправлено",
        enqueued: "В очереди",
        read: "Прочитано",
    };

    const fetchSummary = async () => {
        try {
            setError("");
            const params = {
                from: fromDate,
                to: toDate,
            };

            if (role === "Админ" && selectedPartner) {
                params.partnerName = selectedPartner;
            }

            if (role === "Партнер") {
                params.partnerName = myPartnerName;
            }

            const res = await api.get("/api/messages/allMessages", { params });

            const data = res.data;

            const summary = data.reduce(
                (acc, m) => {
                    acc.total++;

                    if (m.status === "sent") acc.sent++;
                    else if (m.status === "delivered") acc.delivered++;
                    else if (m.status === "failed") acc.error++;

                    return acc;
                },
                { sent: 0, delivered: 0, error: 0, total: 0 }
            );

            setSummary(summary);
        } catch (err) {
            setError(err.response?.data || "Данные не найдены");
            setMessages([]);
            setLoading(false);
        }
    };


    useEffect(() => {
        if (!role) return;
        if (role === "Партнер" && !myPartnerName) return;
        fetchMessages();
    }, [selectedPartner, selectedStatus, selectedDestination, fromDate, toDate]);

    // Summary считается из уже загруженных данных — без лишнего запроса
    useEffect(() => {
        const newSummary = messages.reduce(
            (acc, m) => {
                acc.total++;
                if (m.status === "sent") acc.sent++;
                else if (m.status === "delivered") acc.delivered++;
                else if (m.status === "failed") acc.error++;
                else if (m.status === "enqueued") acc.enqueued++;
                else if (m.status === "read") acc.read++;

                const price = Number(m.price);
                if (!Number.isNaN(price) && price > 0) {
                    acc.totalCost += price;
                }

                return acc;
            },
            { sent: 0, delivered: 0, error: 0, enqueued: 0, read: 0, total: 0, totalCost: 0 }
        );
        setSummary(newSummary);
    }, [messages]);

    const totalPages = Math.max(1, Math.ceil(messages.length / items_per_page));

    const paginatedMessages = messages.slice(
        (currentPage - 1) * items_per_page,
        currentPage * items_per_page
    );

    const goToPrevPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };

    const goToNextPage = () => {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    };

    return (
        <div className="messages-main">
            <div className="tableWrapperMessages">
                <h1>Сообщения</h1>

                <form className="date-filter" onSubmit={handleFilterSubmit}>
                    <div className="filters-row">
                        {role === "Админ" && (
                            <label>
                                Партнер:
                                <select value={selectedPartner} onChange={handleSelectChange}>
                                    <option value="">Все</option>
                                    {partners.map((p) => (
                                        <option key={p.id} value={p.name}>
                                            {p.name}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        )}

                        <label>
                            Статус:
                            <select
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="">Все статусы</option>

                                {Object.entries(statusTranslations).map(([value, label]) => (
                                    <option key={value} value={value}>
                                        {label}
                                    </option>
                                ))}
                            </select>
                        </label>

                        <label>
                            Номер (Destination):
                            <input placeholder='Поиск'
                                type="text"
                                value={selectedDestination}
                                onChange={(e) => { setSelectedDestination(e.target.value) }}
                            />
                        </label>
                    </div>

                    <div className="filters-row">
                        <label>
                            С:
                            <input
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </label>

                        <label>
                            По:
                            <input
                                type="date"
                                value={toDate}
                                min="1900-01-01"
                                max="2999-12-31"
                                onChange={(e) => setToDate(e.target.value)}
                            />
                        </label>

                    </div>
                </form>

                {error && <p className="error">{error}</p>}

                <div className="summary-grid">
                    <div className="summary-box">
                        <p>Отправлено</p>
                        <b>{summary.sent}</b>
                    </div>

                    <div className="summary-box">
                        <p>Доставлено</p>
                        <b>{summary.delivered}</b>
                    </div>

                    <div className="summary-box">
                        <p>Не отправлено</p>
                        <b>{summary.error}</b>
                    </div>

                    <div className="summary-box">
                        <p>В очереди</p>
                        <b>{summary.enqueued}</b>
                    </div>

                    <div className="summary-box">
                        <p>Прочитано</p>
                        <b>{summary.read}</b>
                    </div>

                    <div className="summary-box">
                        <p>Итого</p>
                        <b>{summary.total}</b>
                    </div>

                    <div className="summary-box summary-box-cost">
                        <p>Сумма</p>
                        <b>{formatCost(summary.totalCost)}</b>
                    </div>
                </div>

                <div className={loading || messages.length === 0 ? 'tableWrapperInnerSMall' : 'tableWrapperInner'}>
                    <table>
                        <thead>
                            <tr>
                                <th>Партнер</th>
                                <th>Номер</th>
                                <th>Статус</th>
                                <th>Дата/время</th>
                                <th>Цена</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center" }}>
                                        Загрузка...
                                    </td>
                                </tr>
                            ) :
                                messages.length > 0 ? (
                                    paginatedMessages.map((m, i) => (
                                        <tr key={i}>
                                            <td>{m.partner}</td>
                                            <td>{m.destination}</td>
                                            <td>{statusTranslations[m.status] || m.status}</td>
                                            <td>
                                                {new Date(m.date).toLocaleString()}
                                            </td>
                                            <td>{m.price || "-"}</td>
                                            <td className='history'>
                                                <button className="edit-btn" onClick={() => openHistoryModal(m)}>
                                                    История
                                                </button>
                                                <button className="edit-btn-mobile" onClick={() => openHistoryModal(m)}>
                                                    <img src={historyLogo} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>
                                            {error || "Нет данных"}
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {!loading && messages.length > 0 && (<div className="pagination">
                    <button
                        onClick={goToPrevPage}
                        disabled={currentPage === 1}
                    >
                        Назад
                    </button>

                    <span>
                        Страница {currentPage} из {totalPages}
                    </span>

                    <button
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                    >
                        Вперед
                    </button>
                </div>)}
            </div>
            {isHistoryOpen && (
                <div className="modalOverlay">
                    <div className="modalPartnersHistory">
                        <div className="modalTop">
                            <h3>История сообщения</h3>
                            <button type="button" onClick={closeHistoryModal}></button>
                        </div>

                        <div className="modalInfoHistory">
                            <p>Партнер: <b>{partnerWithSelectedMessage}</b></p>
                            <p>Номер: <b>{selectedMessageInfo?.destination}</b></p>
                            <p>Статус: <b>{statusTranslations[selectedMessageInfo?.status] || selectedMessageInfo?.status}</b></p>
                        </div>

                        <div className="historyBody">
                            <div className="history">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Статус</th>
                                            <th>Дата и время</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedMessageHistory.length > 0 ? (
                                            selectedMessageHistory.map((h, i) => (
                                                <tr className="historyLine" key={i}>
                                                    <td>{statusTranslations[h.status] || h.status}</td>
                                                    <td>{new Date(h.date).toLocaleString()}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" style={{ textAlign: "center" }}>
                                                    История пуста
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}